import React, { Component } from 'react';
import Modal from 'react-modal'
import './../../css/LoginSSO.css';
Modal.setAppElement('body');
export default class ForgottenPassword extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            username: '',
        };
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleSendPassword = this.handleSendPassword.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const { value, name } = event.target;
        this.setState({ [name]: value });
    }

    handleOpenModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }
    handleSendPassword(event) {
        event.preventDefault();
        fetch('sendPassword?username=' + this.state.username, {
            method: 'POST',
        }).then(result => {
            this.setState({ showModal: false });
        })
    }

    render() {
        const { composingLabel } = this.props;

        return (
            <div className='forgottenPassword'>
                <a className={this.props.classForThemeColor ? this.props.classForThemeColor : ''} href="#" onClick={this.handleOpenModal}>{composingLabel('sportOauthLabel.forgotYourPass', 'Forgot your password?')}</a>
                <Modal className="Modal forgottenPasswordModal" overlayClassName="Overlay forgottenPasswordModalOverlay" isOpen={this.state.showModal}>
                    <p className='forgoten-text'>{composingLabel('sportOauthLabel.forgottenPass', 'Forgotten password?')}</p>
                    <p>{composingLabel('sportOauthLabel.changePassword.forgottenPassInstruction', 'Don\'t worry! Just enter your username in field below and we will send you Confirmation reset code to your email address.')}</p>
                    <div className='inputFieldForgotten'>
                        <p>{composingLabel('sportOauthLabel.username', 'Username', false)}</p>
                        <input name="username" className='inputForgottenPassword' type='text' value={this.state.username} onChange={this.handleChange} />
                    </div>
                    <p>{composingLabel('sportOauthLabel.changePassword.ifForgottenUsername', 'If you forgot your username ')}&nbsp;<a href="#" className='support-link'>{composingLabel('sportOauthLabel.contactSupportTeam', 'contact our support team')}</a>.</p>
                    <div className='buttonContainer'>
                        <button id="close" className='forgoten-button-cancel' onClick={this.handleCloseModal}>{composingLabel('sportOauthLabel.cancel', 'Cancel')}</button>
                        <button className='forgoten-button' onClick={this.handleSendPassword}>{composingLabel('sportOauthLabel.sendNewPass', 'Send me password')}</button>
                    </div>
                </Modal>
            </div >
        );
    }


}


// WEBPACK FOOTER //
// ./src/main/resources/js/components/forgottenPassword/ForgottenPassword.js